module.exports = __webpack_public_path__ + "img/1.c0cf903f.svg";